import { axios } from '@slg/web-customer-shared';

const apiDomain = 'management/public/v1/platform-settings';

const getFeatureFlags = () => axios.get(`${apiDomain}`);

export default { getFeatureFlags };
